import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Image } from "primereact/image";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { fetchMaintenanceStatus } from "../../redux/slices/maintenanceSlice";

const AuthLayout: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const { currentUser } = useSelector((state: RootState) => state.auth);
  const { isInMaintenance, isLoading } = useSelector(
    (state: RootState) => state.maintenance
  );

  const silentLogout = async () => {
    navigate("/auth", { replace: true });
  };

  useEffect(() => {
    dispatch(fetchMaintenanceStatus());
  }, [dispatch]);

  useEffect(() => {
    // Redirect CUSTOMER to maintenance page if maintenance mode is active
    if (
      !isLoading &&
      isInMaintenance &&
      currentUser?.role?.role_code === "CUSTOMER"
    ) {
      navigate("/maintenance", { replace: true });
    } else if (!currentUser) {
      navigate("/auth", { replace: true });
    }
  }, [isInMaintenance, isLoading, currentUser, navigate]);

  return (
    <section className="flex container justify-center">
      <div className="w-full flex flex-col items-center lg:w-2/3 h-full my-20">
        <Image
          src="/assets/images/logo.png"
          alt="wacepay logo"
          width="180"
          className="mx-auto"
        />
        <Outlet />
      </div>
    </section>
  );
};

export default AuthLayout;
